import { GetMediumListResponse } from '../../../commons/kymw02/api-services/get-medium-list.service';
/**
 * コピー設定画面の値を管理するクラス
 *
 * @export KYMW4401Model
 * @class KYMW4401Model
 */
export class KYMW4401Model {
  mediumType: string;
  coopCode: string;

  mediumList: GetMediumListResponse = [];

  orderCodeOrigin: string;
  catalogIdOrigin: string;

  orderCodeFromCopy: string;
  orderCodeToCopy: string;
  catalogIdFromCopy: string;
  catalogIdToCopy: string;

  get dspMediumType(): string {
    const name = this.mediumList.find(
      _ => this.mediumType === _.MediumType
    )?.MediumName;
    if (!name) return '';
    return this.mediumType + ':' + name;
  }
}
